// cleanup_convert_to_typescript_file_GENERICS

export default {
  'common.accept': 'Accept',
  'common.accepted': 'Accepted',
  'common.account': 'Account',
  'common.accountActivity': 'Account Activity',
  'common.accountBalance': 'Account Balance',
  'common.accountDetails': 'Account Details',
  'common.accountInformation': 'Account Information',
  'common.accountList': 'Account List',
  'common.accountName': 'Account Name',
  'common.accountNumber': 'Account Number',
  'common.accountOverview': 'Account Overview',
  'common.accountTransfers': 'Account Transfers',
  'common.accountType': 'Account Type',
  'common.accounts': 'Accounts',
  'common.accountsNumber': 'Accounts Number',
  'common.achApprovals': 'ACH Approvals',
  'common.achCompany': 'ACH Company',
  'common.achImport': 'ACH Import',
  'common.achPassThrough': 'ACH Pass-Thru',
  'common.achPassThroughFailed': 'ACH Pass-Thru failed',
  'common.achPositivePay': 'ACH Positive Pay',
  'common.achReversals': 'ACH Reversals',
  'common.achSender': 'ACH Sender',
  'common.achTransactions': 'ACH Transactions',
  'common.achTransfer': 'ACH Transfer',
  'common.action': 'Action',
  'common.actionType': 'Action Type',
  'common.actions': 'Actions',
  'common.activate': 'Activate',
  'common.deactivate': 'Deactivate',
  'common.activated': 'Activated',
  'common.activationTime': 'Activation Time',
  'common.active': 'Active',
  'common.activeNow': 'Active Now',
  'common.add': 'Add',
  'common.addAContact': 'Add a Contact',
  'common.addANewTemplate': 'Add A New Template',
  'common.addAPayee': 'Add a Payee',
  'common.addAReceiver': 'Add A Receiver',
  'common.addContact': 'Add Contact',
  'common.addNewAlert': 'Add New Alert',
  'common.addNewUser': 'Add New User',
  'common.addPayee': 'Add Payee',
  'common.modifyPayee': 'Modify Payee',
  'common.addTransactionFailed': 'Add Transaction failed',
  'common.addenda': 'Addenda',
  'common.addendaOrObi': 'Addenda/OBI',
  'common.addendaInformation': 'Addenda Information',
  'common.addendaType': 'Addenda Type',
  'common.addendumEntityId': 'Addendum Entity ID',
  'common.addWidget': 'Add Widget',
  'common.addWidgetScreenreader': 'Add widget to workspace',
  'common.manageWorkspace.help': 'Limit of <%=max%> widgets per workspace (<%=count%>/<%=max%>)',
  'common.additionalDetails': 'Additional Details',
  'common.additionalItem': 'Additional Item',
  'common.additionalTransfer': 'Additional Transfer',
  'common.address': 'Address',
  'common.address1': 'Line 1',
  'common.address2': 'Line 2',
  'common.addressLine1': 'Address Line 1',
  'common.addressLine2': 'Address Line 2',
  'common.addressLine3': 'Address Line 3',
  'common.after': 'After',
  'common.alerts': 'Alerts',
  'common.alertDetails': 'Alert Details',
  'common.all': 'All',
  'common.allAccounts': 'All Accounts',
  'common.allBatches': 'All Batches',
  'common.allCompanies': 'All Companies',
  'common.allInstructions': 'All Instructions',
  'common.allPayees': 'All Payees',
  'common.allReports': 'All Reports',
  'common.allStopPayments': 'All Stop Payments',
  'common.allTemplates': 'All Templates',
  'common.allTransactionZero': 'All transaction amounts set to $0.00',
  'common.allTransactionZeroFailed': 'Failed to set all transaction amounts to $0.00',
  'common.allTransactions': 'All Transactions',
  'common.allUsers': 'All Users',
  'common.allowFreeformPayments': 'Allow Free-Form Payments',
  'common.amount': 'Amount',
  'common.amountExceedsDailyLimit': 'Amount exceeds daily Limit',
  'common.amountToBeDebited': 'Amount to be Debited',
  'common.amountToBeSent': 'Amount to be Sent:',
  'common.amountToCollect': 'Amount To Collect',
  'common.amountToDraw': 'Amount To Draw',
  'common.amountToSend': 'Amount To Send',
  'common.amountType': 'Amount Type',
  'common.and': 'and',
  'common.answer': 'Answer',
  'common.anyAmount': 'Any Amount',
  'common.anyCredit': 'Any Credit',
  'common.anyDebit': 'Any Debit',
  'common.apply': 'Apply',
  'common.approvalDate': 'Approval Date',
  'common.approvalUser': 'Approver',
  'common.approve': 'Approve',
  'common.approvingAction': 'Approving',
  'common.approvePayment': 'Approve Payment',
  'common.approveTransfer': 'Approve Transfer',
  'common.approved': 'Approved',
  'common.approving': 'Approving...',
  'common.appTitle': 'Bottomline Technologies',
  'common.asOfDate': 'As Of Date',
  'common.assignAlerts': 'Assign Alerts',
  'common.associateReportType': 'Associate Report Type',
  'common.auditReport': 'Audit Report',
  'common.auto': 'Auto',
  'common.available': 'Available',
  'common.availableBalanceAmount': '(<%= amount %> Available)',
  'common.availableAccounts': 'Available Accounts',
  'common.availableBalance': 'Available Balance',
  'common.back': 'Back',

  'common.baiFormat': 'BAI Format',
  'common.balances': 'Balances',
  'common.balanceTransactionSearchDetails': 'Balance Transaction Search Details',
  'common.bankBranchCountryCode': 'Bank Branch Country Code',
  'common.bankCode': 'Bank Code',
  'common.bankId': 'Bank Id',
  'common.bankCodeName': 'Bank Code/Name',
  'common.bankCodeType': 'Bank Code/Type',
  'common.bankIdNumber': 'Bank Id Number',
  'common.bankIdNumberType': 'Bank Id Number Type',
  'common.bankInformation': 'Bank Information',
  'common.bankName': 'Bank Name',
  'common.bankNo': 'Bank No',
  'common.bankReference': 'Bank Reference',
  'common.bankRefNumber': 'bankRefNumber',
  'common.bankTrace': 'Bank Trace',
  'common.bankTraceNumber': 'Bank Trace Number',
  'common.batchCode': 'Batch Code',
  'common.batchDescription': 'Batch Description',
  'common.batchImportSummary': 'Batch Import Summary',
  'common.batchLimit': 'Batch Limit',
  'common.batchName': 'Batch Name',
  'common.batchTemplate': 'Batch Template',
  'common.selectedAccounts': 'Selected Accounts',
  'common.beneficiary': 'Beneficiary',
  'common.beneficiaryAccount': 'Beneficiary Account',
  'common.beneficiaryAccountNumber': 'Beneficiary Account Number',
  'common.beneficiaryBank': 'Beneficiary Bank',
  'common.beneficiaryBankRoutingNumber': 'Beneficiary Bank Code / Number',
  'common.beneficiaryId': 'Beneficiary ID',
  'common.beneficiaryInformation': 'Beneficiary Information',
  'common.beneficiaryName': 'Beneficiary Name',
  'common.between': 'Between',
  'common.brandLogo': 'Brand logo',
  'common.btrAccountDetails': '<%=account%> Account Details',
  'common.buildingNumber': 'Building Number',
  'common.bulletins': 'Bulletins',
  'common.business': 'Business',
  'common.businessday': 'business day',
  'common.button': 'button',
  'common.by': 'By',
  'common.byAccount': 'By Account',
  'common.byLabel': 'By',
  'common.byUser': 'By User',
  'common.bypassedDebitCredit': 'Bypassed Debit/Credit',
  'common.cancel': 'Cancel',
  'common.canceling': 'Canceling...',
  'common.change': 'Change',
  'common.changePassword': 'Change password',
  'common.channel': 'Channel',
  'common.charges': 'Charges',
  'common.check': 'Check',
  'common.checkPositivePay': 'Check Positive Pay',
  'common.checkIssueNumber': 'Check Issue Number',
  'common.checkNumber': 'Check Number',
  'common.checkNumberOrRange': 'Check Number/Range',
  'common.city': 'City',
  'common.clear': 'Clear',
  'common.cleared': 'Cleared',
  'common.close': 'Close',
  'common.closingAvailable': 'Closing Available',
  'common.closingBalance': 'Closing Balance',
  'common.code': 'Code',
  'common.collect': 'Collect',
  'common.collectPayment': 'Collect Payment',
  'common.collection': 'Collection',
  'common.comment': 'Comment',
  'common.comments': 'Comments',
  'common.commentsForPayee': 'Comments for Payee',
  'common.compId': 'Company ID',
  'common.companyEntryDescription': 'Company Entry Description',
  'common.companyName': 'Company Name',
  'common.complete': 'Complete',
  'common.completeDeliveryPoints': 'Complete one or more of the following contacts assign alerts',
  'common.confirm': 'Confirm',
  'common.confirmation': 'Confirmation',
  'common.confirmationInfo': 'Confirmation Info',
  'common.confirming': 'Confirming...',
  'common.contactBusiness': 'Contact Business',
  'common.contactCenterApprovePayee': 'Contact Center Approve Payee',
  'common.contactName': 'Contact Name',
  'common.contactPerson': 'Contact Person',
  'common.continue': 'Continue',
  'common.continuing': 'Continuing',
  'common.copied': 'Copied',
  'common.copy': 'Copy',
  'common.copying': 'Copying...',
  'common.copyAs': 'Copy As',
  'common.copyAsNewPayment': 'Copy as New Payment',
  'common.copyAsPayment': 'Copy as Payment',
  'common.copyAsTemplate': 'Copy as Template',
  'common.copyUser': 'Copy User',
  'common.correspondentFinancialInformation': 'Correspondent Financial Information',
  'common.correspondentFinancialInstitution': 'Correspondent Financial Institution',
  'common.count': 'Count',
  'common.country': 'Country',
  'common.countryCode': 'Country Code',
  'common.create': 'Create',
  'common.createPayment': 'Create Payment',
  'common.createPaymentTemplate': 'Create Payment Template',
  'common.createRecurringInstruction': 'Create Recurring Instruction',
  'common.createRecurringTransferInstruction': 'Create Recurring Transfer Instruction',
  'common.createTemplate': 'Create Template',
  'common.createdBy': 'Created By',
  'common.credit': 'Credit',
  'common.creditAmount': 'Credit Amount',
  'common.creditCount': 'Credit Count',
  'common.creditSlashDebit': 'Debit/Credit',
  'common.credits': 'Credits',
  'common.creditsBypassed': 'Credits Bypassed',
  'common.csvFormat': 'CSV (Delimited)',
  'common.currency': 'USD',
  'common.currencyNote': '<%= amount %> USD',
  'common.currencySymbol': '$',
  'common.currencyZeroDollarAmount': '$0.00',
  'common.currencyWord': 'Currency',
  'common.currentAvailable': 'Current Available',
  'common.currentLedger': 'Current Ledger',
  'common.currentPrincipal': 'Current Principal',
  'common.custNo': 'Cust No',
  'common.custTraceNum': 'Customer Trace',
  'common.customRange': 'Custom Range',
  'common.customRateConfirmation': 'Custom Rate Confirmation',
  'common.customerCode': 'Customer ID',
  'common.customerId': 'Customer ID',
  'common.customerRefBankNumber': 'Cust. Ref. / Check Number',
  'common.customerTrace': 'Customer Trace',
  'common.customerTraceNumber': 'Customer Trace Number',
  'common.cutoffTime': 'Cutoff Time',
  'common.dailyLimit': 'Daily limit',
  'common.date': 'Date',

  'common.dateRange': 'Date Range',
  'common.dateTime': 'Date and Time',
  'common.dates': 'Dates',
  'common.day': 'day',
  'common.dayOfWeek': 'Day of the Week',
  'common.dayOfMonth': 'Day of the Month',
  'common.debit': 'Debit',
  'common.debitAmount': 'Debit Amount',
  'common.debitCount': 'Debit Count',
  'common.debitCredit': 'Debit / Credit',
  'common.debits': 'Debits',
  'common.debitsBypassed': 'Debits Bypassed',
  'common.decisionsFor': 'Decisions For',
  'common.default': 'Default',
  'common.delay': 'Delay',
  'common.delete': 'Delete',
  'common.deleteConfirmation': 'Are you sure you want to delete?',
  'common.deletePayment': 'Delete Payment',
  'common.deleteTransactionFailed': 'Delete Transaction failed',
  'common.deleteTransfer': 'Delete Transfer',
  'common.deleted': 'Deleted',
  'common.deletingAction': 'Deleting',
  'common.deleting': 'Deleting...',
  'common.delimited': 'Delimited',
  'common.delimiter': 'Delimiter',
  'common.deliverTo': 'Deliver To',
  'common.deliveryPoint': 'Delivery Point',
  'common.deliveryPoints': 'Delivery Points',
  'common.deliveryPointsHeaderText': 'Delete Delivery Point',
  'common.deliveryPointsModalSubText': 'Do you want to proceed?',
  'common.deliveryPointsModalText': 'You are about to permanently remove this Delivery Point.',
  'common.deposit': 'Deposit',
  'common.depositAccount': 'Deposit Account',
  'common.depositAccountRequired': 'Deposit Account is required to initiate a payment',
  'common.depositAccounts': 'Deposit Accounts',
  'common.depositTo': 'Deposit To',
  'common.deposits': 'Deposits',
  'common.description': 'Description',
  'common.descriptiveDate': 'Descriptive Date',
  'common.destinationCurrency': 'Destination Currency',
  'common.details': 'Details',
  'common.directConnectId': 'DirectConnect ID',
  'common.disable': 'Disable',
  'common.disabling': 'Disabling...',
  'common.discData': 'Disc Data',
  'common.discard': 'Discard',
  'common.discretionaryData': 'Discretionary Data',
  'common.dismiss': 'Dismiss',
  'common.done': 'Done',
  'common.download': 'Download',
  'common.drawFrom': 'Draw From',
  'common.dropzoneRestrictionText': '1 file maximum. 999 records per file maximum.',
  'common.edit': 'Edit',
  'common.activationUser': 'Initiator',

  'common.editTransaction': 'Edit Transaction',
  'common.effectiveDate': 'Effective Date',
  'common.effectiveEntryDate': 'Effective Entry Date',
  'common.email': 'Email',
  'common.email2': 'Email 2',
  'common.emailAddress': 'Email Address',
  'common.emailAddress.error': 'Invalid email address format, please verify',
  'common.emailError': 'Invalid email address',
  'common.employee': 'Employee',
  'common.employeePaymentDetails': 'Employee Payment Details',
  'common.employeePayments': 'Employee Payments',
  'common.enable': 'Enable',
  'common.enabled': 'Enabled',
  'common.enabling': 'Enabling...',
  'common.end': 'End',
  'common.enroll': 'Enroll',
  'common.entered': 'Entered',
  'common.enteredBy': 'Entered By',
  'common.entitlements': 'Entitlements',
  'common.entity': 'Entity',
  'common.entryDate': 'Entry Date',
  'common.entryMethod': 'Entry Method',
  'common.equals': 'Equals',
  'common.equalTo': 'Equal To',
  'common.error': 'Error',
  'common.errorDetails': 'Error Details',
  'common.errorMessage': 'Error Message',
  'common.errorMessages': 'Error Messages',
  'common.escrow': 'Escrow',
  'common.events': 'Events',
  'common.every': 'every',
  'common.exceptionDetails': 'Exception Details',
  'common.exceptionId': 'Exception ID',
  'common.exceptionReason': 'Exception Reason',
  'common.exceptions': 'Exceptions',
  'common.exceptionsReview': 'Exceptions To Review',
  'common.exchangeRate': 'Exchange Rate',
  'common.exit': 'Exit',
  'common.expedited': 'Expedited',
  'common.expired': 'Expired',
  'common.export': 'Export',
  'common.exportType': 'Export Type',
  'common.ext': 'Ext',
  'common.modifyRecurringInstruction': 'Modify Recurring Instruction',
  'common.extension': 'Extension',

  'common.fail': 'Fail',
  'common.failed': 'Failed',
  'common.failedDuplicate': 'Failed-Duplicate',
  'common.failedTo': 'Failed to',
  'common.fax': 'Fax',
  'common.faxNumber.error': 'Invalid fax number',
  'common.field': 'Field',
  'common.field.empty': '- -',
  'common.file': 'File',
  'common.fileImportDetail': 'File Import Detail',
  'common.fileImportSummary': 'File Import Summary',
  'common.fileName': 'File Name',
  'common.fileOutput': 'File Output',
  'common.fileProcessing': 'File Processing...',
  'common.fileTotal': 'File Total',
  'common.fileUploading': 'File Uploading...',
  'common.financialInstitution': 'Financial Institution',
  'common.financialOverviewDepositAccounts': 'Financial Overview Deposit Accounts',
  'common.financialOverviewLoanAccounts': 'Financial Overview Loan Accounts',
  'common.financialOverviewInvestmentAccounts': 'Financial Overview Investment Accounts',
  'common.financialOverviewOtherAccounts': 'Financial Overview Other Accounts',
  'common.first': 'First',
  'common.firstRecordsWillBePrinted': 'First <%= limit %> records will be printed.',
  'common.firstTimeLogin.mobileError': 'As a first time user, login through your computer',
  'common.foreignPaymentAmount': 'Foreign Payment Amount',
  'common.forgotPassword': 'Forgot Password?',
  'common.form': 'Form',
  'common.freeForm': 'Free form',
  'common.freeform': 'Freeform',
  'common.freeformEdit': 'Freeform Edit',
  'common.freeformInformation': 'Freeform Information',
  'common.freeformTransfer': 'freeform transfer',
  'common.freeze': 'Freeze',
  'common.frequency': 'Frequency',
  'common.from': 'From',
  'common.from.lowercase': 'from',
  'common.fromAccount': 'From Account',
  'common.fromAccountName': 'From Account Name',
  'common.fromAccountNumber': 'From Account Number',
  'common.fromAmount': 'From Amount',
  'common.frozen': 'Frozen',

  'common.fundingAccount': 'Funding Account',
  'common.fxIndicator': 'FX Indicator',
  'common.gateway': 'Gateway',
  'common.generate': 'Generate',
  'common.goBack': 'Go Back',
  'common.greaterThan': 'Must be greater than <%= field %>',
  'common.greaterThanLabel': 'Greater Than',
  'common.isGreaterThanLabel': 'Is Greater Than',
  'common.grid.ariaLabel': '<%= colCount %> columns, <%= rowCount %> rows, <%= label %>',
  'common.grid.empty': '-',
  'common.grid.noRecordsFound': 'No records found.',
  'common.grid.selectCheckbox': 'Select checkbox <%= checkbox %>',
  'common.grid.filtersButton': 'Filters',
  'common.grid.columnsToggle': 'Columns',
  'common.header': 'Header',
  'common.hideAdditionalFields': 'Hide Additional Fields',
  'common.hideCheckImage': 'Hide Check Image',

  'common.hideOptionalFields': 'Hide Optional Fields',
  'common.home': 'Home',
  'common.id': 'ID',
  'common.idNumber': 'ID #',
  'common.image': 'Image',
  'common.import': 'Import',
  'common.importBatches': 'Import Batches',
  'common.importFile': 'Import File',
  'common.importFixed': 'Import Fixed',
  'common.importInformation': 'Import Information',
  'common.importIssueDetails': 'Import Issue Details',
  'common.importIssues': 'Import Issues',
  'common.importManager': 'Import Manager',
  'common.importMessages': 'Import Messages',
  'common.importMode': 'Import Mode',
  'common.importNumber': 'Import Number',
  'common.importOverview': 'Import Overview',
  'common.importPaymentReview': 'Import Payment Review',
  'common.importTemplateReview': 'Import Template Review',
  'common.importType': 'Import Type',
  'common.importViewDetails': 'View Details of import.',
  'common.imported': 'Imported',
  'common.importedBy': 'Imported By',
  'common.importedDateTime': 'Imported Date/Time',
  'common.inactive': 'Inactive',
  'common.individual': 'Individual',
  'common.individualName': 'Individual Name',
  'common.initiate': 'Initiate',
  'common.initiatePayment': 'Initiate Payment',
  'common.initiated': 'Initiated',
  'common.initiatedBy': 'Initiated By',
  'common.initiatedDate': 'Initiated Date',
  'common.initiatedDateTime': 'Initiated Date/Time',
  'common.initiating': 'Initiating...',
  'common.instruction': 'Instruction',
  'common.instructionReturn': 'Instruction Return',
  'common.insufficientFunds': 'Insufficient Funds',
  'common.interest': 'Interest',
  'common.intermediary': 'Intermediary',
  'common.intermediaryBank1': 'Intermediary Bank 1',
  'common.intermediaryBank1AddressLine1': 'Intermediary Bank 1 Address Line 1',
  'common.intermediaryBank1AddressLine2': 'Intermediary Bank 1 Address Line 2',
  'common.intermediaryBank2': 'Intermediary Bank 2',
  'common.intermediaryBank2AddressLine1': 'Intermediary Bank 2 Address Line 1',
  'common.intermediaryBank2AddressLine2': 'Intermediary Bank 2 Address Line 2',
  'common.internationalAch': 'International ACH',
  'common.internationalWire': 'International Wire',
  'common.invalidChars': 'You have entered invalid characters.',
  'common.invalidCode': 'Invalid Code',
  'common.invalidCodes': 'Invalid Codes',
  'common.invalidDate': 'Invalid Date',
  'common.invalidEntry': 'Invalid Entry',
  'common.investment': 'Investment',
  'common.investmentAccounts': 'Investment Accounts',
  'common.investmentAccountDetails': 'Investment Account Details',
  'common.isRequired': 'Is required',
  'common.issue': 'Issue',
  'common.issueAmount': 'Issue Amount',
  'common.issueDate': 'Issue Date',
  'common.issueTime': 'Issue Time',
  'common.issueVoidDate': 'Issue/Void Date',
  'common.issuedCheck': 'Issued Check',
  'common.itemCount': 'Item Count',
  'common.itemHistory': 'Item History',
  'common.itemInProcess': 'Item in Process',
  'common.itemStatus': 'Item status',

  'common.items': 'Items',
  'common.last': 'Last',
  'common.lastActivationDate': 'Last Activation Date',
  'common.lastApproved': 'Last approved',
  'common.lastApprover': 'Last approver',
  'common.lastModified': 'Last Modified',
  'common.lastModifiedBy': 'Last Modified By',
  'common.lastModifiedDate': 'Last Modified Date',
  'common.lastModifiedOn': 'Last Modified On',
  'common.lastModifiedTime': 'Last modified time',
  'common.lastModifiedUser': 'Last modified user',
  'common.leadBankCode': 'Lead Bank Code',
  'common.leave': 'Leave',
  'common.leavePage': 'Leave Page',
  'common.length': 'Length',
  'common.less': 'Less',
  'common.lessThan': 'Max length of <%= field %>',
  'common.lessThanLabel': 'Less Than',
  'common.IsLessThanLabel': 'Is Less Than',
  'common.limitRemaining': 'Limit Remaining',
  'common.limits': 'Limits',
  'common.line': 'Line',
  'common.lineOfCredit': 'Line Of Credit Amount',
  'common.loadDate': 'Load date',
  'common.bank.code.invalid': 'Bank Code Invalid',
  'common.loading': 'Loading...',
  'common.loadingFailed': 'Loading Failed',
  'common.loanAccount': 'Loan Account',
  'common.loanAccounts': 'Loan Accounts',
  'common.loanDraw': 'Loan Draw',
  'common.loanPayment': 'Loan Payment',
  'common.lock': 'Lock',
  'common.locked': 'Locked',
  'common.logExportMessage': '<%=widgetName %> exported by <%=userName %>',
  'common.logPrintMessage': '<%=widgetName %> printed by <%=userName %>',
  'common.login': 'Login',
  'common.loggingOut': 'Logging Out...',
  'common.logout': 'Log Out?',

  'common.loginForm': 'Login Form',
  'common.makeDefault': 'Make Default',
  'common.makeRecurring': 'Make this a Recurring Payment',
  'common.manual': 'Manual',
  'common.map': 'Map',
  'common.mapType': 'Map Type',
  'common.mapping': 'Mapping',
  'common.maskAnswers': 'Mask Answers',
  'common.answersSaved': 'Answers Saved',
  'common.manageImportMaps': 'Manage Import Maps',
  'common.maskCharacter': '*',
  'common.maxCharacters': 'Max <%= max %> characters',
  'common.maxRange': 'Maximum range is <%=distance %> <%=type %>',
  'common.maximum': 'Maximum',
  'common.maxlength': 'Max length of <%= maxLength %>',
  'common.memo': 'Memo',
  'common.message': 'Message',
  'common.mobile': 'Mobile',
  'common.modified': 'Modified',
  'common.modify': 'Modify',
  'common.modifying': 'Modifying...',
  'common.modifyAlert': 'Modify Alert',
  'common.modifyAmount': 'Modify Amount',
  'common.modifyAmounts': 'Modify Amounts',
  'common.modifyPayment': 'Modify Payment',
  'common.modifyTemplate': 'Modify Wire Template',
  'common.modifyTransactionFailed': 'Modify Transaction failed',
  'common.modifyTransactions': 'Modify Transactions',
  'common.modifyTransfer': 'Modify Transfer',
  'common.months': 'month(s)',
  'common.more': 'More',
  'common.moreDetails': 'More Details',

  'common.multi': 'MULTI',
  'common.nachaImport': 'NACHA Import',
  'common.nachaImportInformation': 'NACHA Import information',
  'common.name': 'Name',
  'common.nameMustBeUnique': 'Name must be unique',
  'common.new': 'New',
  'common.newBulletins': 'New Bulletins',
  'common.newTransactionDate': 'New Transaction Date',
  'common.newUsers': 'New Users',
  'common.next': 'Next',
  'common.nextDate': 'Next Date',
  'common.nextTransferStartDate': 'Next Transfer Date',
  'common.nextTransferStartDateSubtext':
    'Please select date at least one business day after initial Transfer Date',
  'common.nickName': 'Nickname',
  'common.ok': 'Ok',
  'common.no': 'No',
  'common.noAccountsPermitted': 'No Accounts have been permitted',
  'common.noDataAvailable': 'No Data Available',
  'common.noDataFound': 'No Data Found',
  'common.noInformationToDisplay': 'No information to display',
  'common.noProcessingToday': 'No processing today',
  'common.notAvailable': 'Not Available',
  'common.notFound': 'Request not found',
  'common.numberPostfix.nd': 'nd',
  'common.numberPostfix.rd': 'rd',
  'common.numberPostfix.st': 'st',
  'common.numberPostfix.th': 'th',

  'common.obiInfo': 'OBI Info',
  'common.of': 'Of',
  'common.ofErrors': 'Of Errors',
  'common.offsetAccount': 'Offset Account',
  'common.onLabel': 'on',
  'common.or': 'or',
  'common.optional': 'Optional',
  'common.originalPayment': 'Original Payment',
  'common.originatingBankDetails': 'Originating Bank Details',
  'common.originatingBankName': 'Originating Bank Name',
  'common.originatingPartyDetails': 'Originating Party Details',
  'common.originationCurrency': 'Origination Currency',
  'common.originatorId': 'Originator ID',
  'common.originatorInformation': 'Originator Information',
  'common.originatorName': 'Originator Name',
  'common.other': 'Other',
  'common.otherAccounts': 'Other Accounts',
  'common.otherAccountDetails': 'Other Account Details',
  'common.otherPotentialDuplicates': 'other potential duplicates',
  'common.outstandingBalance': 'Outstanding Balance',
  'common.overview': 'Overview',

  'common.paidAmount': 'Paid amount',
  'common.paidChecks': 'Paid Checks',
  'common.paidDate': 'Paid Date',
  'common.parameters': 'Parameters',
  'common.password': 'Password',
  'common.pay': 'Pay',
  'common.payee': 'Payee',
  'common.payees': 'Payees',
  'common.payeeAccount': 'Payee Account',
  'common.payeeDirectory': 'Payee Directory',
  'common.payeeInfo': 'Payee info',
  'common.payeeInformation': 'Payee Information',
  'common.payeeName': 'Payee name',
  'common.payment': 'Payment',
  'common.paymentAmount': 'Payment Amount',
  'common.paymentCategory': 'Payment Category',
  'common.paymentCenter': 'Payment Center',
  'common.paymentCreated': 'Payment Created',
  'common.paymentCopied': 'Payment Copied',
  'common.paymentModified': 'Payment Modified',
  'common.paymentDate': 'Payment Date',
  'common.paymentDeliveryDate': 'Payment Delivery Date',
  'common.paymentDescription': 'Payment Description',
  'common.paymentDetails': 'Payment Details',
  'common.paymentEntryDescription': 'Payment Entry Description',
  'common.paymentInformation': 'Payment Information',
  'common.paymentLimitWarning': 'Payment initiated with warnings',
  'common.paymentMethod': 'Payment Method',
  'common.paymentName': 'Payment Name',
  'common.paymentOptions': 'Payment Options',
  'common.paymentStatus': 'Payment Status',
  'common.paymentFailed': 'Payment submission failed.',
  'common.paymentSubmittedWithWarnings': 'Payment submitted with warnings',
  'common.paymentTemplateConfirmation': 'Payment Template Confirmation',
  'common.paymentTemplateType': 'Payment Template Type',
  'common.paymentTemplates': 'Payment Templates',
  'common.paymentType': 'Payment Type',
  'common.paymentRejectedBy': 'Rejected By',
  'common.paymentRejectedOn': 'Rejected Date',
  'common.enteredOn': 'Entered On',
  'common.passwordExpirationAlert':
    'Your password will expire in <%=passwordExpirationDays%> days.',
  'common.paymentUpdated': 'Payment Updated',
  'common.paymentsConfirmation': 'Payments Confirmation',
  'common.payments': 'Payments',
  'common.pending': 'Pending',
  'common.pendingApproval': 'Pending Approval',
  'common.permissions': 'Permissions',
  'common.phone': 'Phone',
  'common.phoneNumber.error': 'Invalid phone number',
  'common.placeholder': 'Placeholder',
  'common.position': 'Position',
  'common.positivePay': 'Positive Pay',
  'common.possibleActions': 'Possible Actions',
  'common.postalCode': 'Postal Code',
  'common.prenote': 'Prenote',
  'common.preparingForPrint': 'Preparing for print.',
  'common.principal': 'Principal',
  'common.print': 'Print',
  'common.printableView': 'Printable View',
  'common.prior': 'Prior',
  'common.proceed': 'Proceed',
  'common.proceedQuestion': 'Do you want to proceed?',
  'common.process': 'Process',
  'common.processMode': 'Process Mode',
  'common.processing': 'Processing',
  'common.addReceiversLater': 'Add Receivers Later',
  'common.processed': 'Processed',
  'common.processingDate': 'Processing Date',
  'common.province': 'Province',
  'common.stateProvince': 'Province/State',
  'common.purposeOfWire': 'Purpose of wire',
  'common.qboFormat': 'QuickBooks (QBO)',
  'common.qfxFormat': 'Quicken (QFX)',
  'common.question': 'Question',
  'common.range': 'Range',
  'common.reason': 'Reason',
  'common.reasonForReversal': 'Reason for Reversal',
  'common.receiveFrom': 'Receive From',
  'common.received': 'Received',
  'common.receiverId': 'Receiver ID',
  'common.receiverInformation': 'Receiver Information',
  'common.receiverName': 'Receiver Name',
  'common.receiverSaved': 'Receiver Saved',
  'common.receivingBankDetails': 'Receiving Bank Details',
  'common.receivingBankName': 'Receiving Bank Name',
  'common.receivingCompany': 'Receiving Company',
  'common.receivingPartyDetails': 'Receiving Party Details',
  'common.record': 'Record',
  'common.recordNumber': 'Record Number',
  'common.recordsInFile': 'Records in File',
  'common.recurring': 'Recurring',
  'common.recurringInstruction': 'Recurring Instruction',
  'common.recurringInstructionAdded': 'Recurring Instruction Added',
  'common.recurringInstructions': 'Recurring Instructions',
  'common.recurringPayment': 'Recurring Payment',
  'common.recurringTransfers': 'Recurring Transfers',
  'common.referenceNumber': 'Reference Number',
  'common.regular': 'Regular',
  'common.reject': 'Reject',
  'common.rejectingAction': 'Rejecting',
  'common.rejecting': 'Rejecting...',
  'common.rejectPayment': 'Reject Payment',
  'common.rejectTransfer': 'Reject Transfer',
  'common.rejected': 'Rejected',
  'common.rejectedPayments': 'Rejected Payments',
  'common.remainingApproval': 'Remaining Approval',
  'common.remittanceAdvice': 'Remittance Advice',
  'common.remove': 'Remove',
  'common.replacement': 'Replacement',
  'common.reportError': 'There are no Electronic Reports setup for the user',
  'common.reportName': 'Report Name',
  'common.reportSearchCriteria': 'Report Search Criteria',
  'common.reportType': 'Report Type',
  'common.reports': 'Reports',
  'common.requestPayment': 'Request Payment',
  'common.resend': 'Re-send Code',
  'common.reset': 'Reset',
  'common.reset.successful': 'Reset Successful',
  'common.resetPassword': 'Reset Password',
  'common.resize': 'Resize',
  'common.response': 'Response',
  'common.return': 'Return',
  'common.returnReason': 'Return reason',
  'common.reversal': 'Reversal',
  'common.reversalReason': 'Reversal Reason',
  'common.reversals': 'Reversal(s)',
  'common.reverse': 'Reverse',
  'common.reversedAmount': 'Reversed Amount',
  'common.reversedCredits': 'Reversed Credits',
  'common.reversedDebits': 'Reversed Debits',
  'common.reviewTransactionUpload': 'Review Transaction Upload',
  'common.routingNumber': 'Bank Code / Number',
  'common.ruleName': 'Rule Name',
  'common.run': 'Run',
  'common.runningBalance': 'Running Balance',
  'common.runningTotal': 'Running Total',
  'common.today': 'Today',
  'common.last7days': 'Last 7 days',
  'common.last7Days': 'Last 7 Days',
  'common.monthToDate': 'Month to Date',
  'common.quarterToDate': 'Quarter to Date',
  'common.lastMonth': 'Last Month',
  'common.paymentFraudControl': 'Payment Fraud Control',
  'common.previousMonth': 'Previous Month',
  'common.previousBusinessDay': 'Previous Business Day',
  'common.sameDay': 'Same Day',
  'common.sameDaySettlement': 'Same Day Settlement',
  'common.last30days': 'Last 30 Days',
  'common.last60days': 'Last 60 Days',
  'common.last90days': 'Last 90 Days',
  'common.yearToDate': 'Year to Date',
  'common.sameDaySettlementAdditionalFee': 'Additional fees may apply for same day settlements',
  'common.sameDaySettlementAvailable': 'Same Day settlement available. Additional fee may apply.',
  'common.checkDetails': 'Check Details',
  'common.save': 'Save',
  'common.save&Continue': 'Save & Continue',
  'common.save&EditNext': 'Save & Edit Next',
  'common.saving': 'Saving...',
  'common.schedule': 'Schedule',
  'common.search': 'Search',
  'common.second': 'Second',
  'common.changeSecurityQuestions': 'Change Security Questions',
  'common.security.title': 'Security Question Challenge',
  'common.select': 'Select',
  'common.selectAccounts': 'Select Accounts',
  'common.selectAll': 'Select All',
  'common.selectCompanies': 'Select Companies',
  'common.selectFile': 'select file',
  'common.selectPaymentSet': 'Select Payment Set',
  'common.selectReturnReason': 'Select Return Reason',
  'common.selectTransactions': 'Select Individual Transactions',
  'common.selectType': 'Select Type',
  'common.selectedCredits': 'Selected Credits',
  'common.selectedDebits': 'Selected Debits',
  'common.send': 'Send',
  'common.sendFrom': 'Send From',
  'common.sendPayment': 'Send Payment',
  'common.sendReversal': 'Send Reversal',
  'common.sendTo': 'Send To',
  'common.sending': 'Sending',
  'common.sendingFrom': 'Sending From',
  'common.sendingTo': 'Sending To',
  'common.sequenceNumber': 'Sequence number',
  'common.serialNumber': 'Serial Number',
  'common.serverError': 'Server Error',
  'common.server.error':
    'System error, please try back later. If problem persists, contact your administrator.',
  'common.service': 'Service',
  'common.sharedCompanyLimit': 'Shared Company Limit',
  'common.sharedCustomerLimit': 'Shared Customer Limit',
  'common.showAdditionalFields': 'Show Additional Fields',
  'common.showCheckImage': 'Show Check Image',
  'common.showDailyLimits': 'Show Daily Limits',
  'common.showLimits': 'Show Limits',
  'common.showOptionalFields': 'Show Optional Fields',
  'common.showReversals': 'Show Reversals',
  'common.showTotals': 'Show Totals',
  'common.simplifiedPayments': 'Simplified Payments',
  'common.single': 'Single',
  'common.skip': 'Skip',
  'common.skipAddingReceiver': 'Skip adding Receiver',
  'common.skipLink': 'Skip to main content',
  'common.smallBusinessPayments': 'Small Business Payments',
  'common.smsNumber': 'SMS Number',
  'common.source': 'Source',
  'common.sourceTemplateName': 'Source Template Name',
  'common.standard': 'Standard',
  'common.standardEntryClassCode': 'Standard Entry Class Code (SEC)',
  'common.state': 'State',
  'common.status': 'Status',
  'common.statusDetails': 'Status Details',
  'common.statusOfTransfer': 'Status of Transfer',
  'common.stopPayments': 'Stop Payments',
  'common.streetName': 'Street Name',
  'common.streetAddress': 'Street Address',
  'common.stiFormat': 'STI CSV',
  'common.submit': 'Submit',
  'common.submitted': 'Payment submitted',
  'common.submitForApproval': 'Submit For Approval',
  'common.submitPayment': 'Submit Payment',
  'common.submittedForApproval': 'Payment has been submitted for approval.',
  'commoon.receivePayment': 'Receive Payment',
  'common.submitting': 'Submitting...',
  'common.submittingPleaseWait': 'Submitting... Please Wait',
  'common.succeeded': 'Succeeded',
  'common.success': 'Success',
  'common.summary': 'Summary',
  'common.somethingWentWrong': 'Something went wrong.',

  'common.summaryBalances': 'Summary Balances',
  'common.tax': 'Tax',
  'common.taxInformation': 'Tax Information',
  'common.taxPayment': 'Tax Payment',
  'common.taxpayer': 'Taxpayer',
  'common.templateNameUnique': 'Template name already used',
  'common.template': 'Template',
  'common.templateCode': 'Template Code',
  'common.templateCopied': 'Template copied',
  'common.importDate': 'Import Date',
  'common.importDetails': 'Import Details',
  'common.importMap': 'Import Map',
  'common.templateCreated': 'Template Created',
  'common.templateId': 'Template ID',
  'common.mapName': 'Map Name',
  'common.templateInformation': 'Template Information',
  'common.failedRecords': 'Failed Records',
  'common.templateName': 'Template Name',
  'common.templateNameWithParam': 'Template-<%= name %>',
  'common.overviewInformation': 'Overview Information',
  'common.templateOrPayment': 'Template Or Payment',
  'common.approvedBy': 'Approved By',
  'common.templatePaymentName': 'Template / Payment Name',
  'common.approvedDate': 'Approved Date',
  'common.templateUpdated': 'Template Updated',
  'common.approvedDateTime': 'Approved Date/Time',
  'common.terms.conditions': 'Terms and Conditions',
  'common.contactInformation': 'Contact Information',
  'common.test': 'Test',
  'common.contactPhone': 'Contact Phone',
  'common.textMessage': 'Text Message',
  'common.birthDate': 'Birth Date',
  'common.third': 'Third',
  'common.businessName': 'Business Name',
  'common.thisActionCannotBeUndone': 'This action cannot be undone',
  'common.addressType': 'Address Type',
  'common.threshold': 'Threshold',
  'common.domestic': 'Domestic',
  'common.timeEntered': 'Time Entered',
  'common.firstName': 'First Name',
  'common.to': 'to',
  'common.importId': 'Import ID',
  'common.to.capitalized': 'To',
  'common.international': 'International',
  'common.toAccount': 'To Account',
  'common.lastName': 'Last Name',
  'common.toAccountName': 'To Account Name',
  'common.middleName': 'Middle Name',
  'common.toAccountNumber': 'To Account Number',
  'common.note': 'Note',
  'common.toAmount': 'To Amount',
  'common.reasonForFailure': 'Reason for Failure',
  'common.todaysOpeningLedger': "Today's Opening Ledger",
  'common.socialSecurityNumber': 'Social Security Number',
  'common.toggle': 'toggle',
  'common.toggleAllRowsSelection': 'Toggle all rows selection',
  'common.successfulRecords': 'Successful Records',
  'common.total': 'Total',
  'common.suffix': 'Suffix',
  'common.templateApproved': 'Template Approved',
  'common.totalActiveCount': 'Total Active Count',
  'common.totalAmount': 'Total Amount',
  'common.totalCount': 'Total Count',
  'common.totalCredits': 'Total Credits',
  'common.totalCreditsSingularOrPlural': 'Total Credit(s)',
  'common.totalCreditsBypassed': 'Total Credits Bypassed',
  'common.totalDebits': 'Total Debits',
  'common.totalDebitsBypassed': 'Total Debits Bypassed',

  'common.totalNumberOfItems': 'Total Number Of Items',
  'common.totalRecords': 'Total Records',
  'common.totalTransfers': 'Total Transfers',
  'common.totals': 'Totals',
  'common.traceNumber': 'Trace number',
  'common.transaction': 'Transaction',
  'common.transactionAdded': 'Transaction added',
  'common.transactionDate': 'Transaction Date',
  'common.transactionDateUpdated': 'Transaction Date Updated',
  'common.transactionDeleted': 'Transaction deleted',
  'common.transactionDescription': 'Transaction Description',
  'common.transactionDetails': 'Transaction Details',
  'common.transactionInformation': 'Transaction Information',
  'common.transactionModified': 'Transaction Modified',
  'common.transactionState': 'Transaction State',
  'common.transactionType': 'Transaction Type',
  'common.transactionType.range':
    'Entering <%= ariaLabel %> as a <%= buttonName %>. Click to enter as <%= inputValue %> value',
  'common.transactions': 'Transactions',
  'common.transactionsUpdated': 'Transactions Updated',
  'common.transfer': 'Transfer',
  'common.transferAmount': 'Transfer Amount',
  'common.transferCenter': 'Transfer Center',
  'common.transferDate': 'Transfer Date',
  'common.transferTemplate': 'transfer template',
  'common.transferTemplates': 'Transfer Templates',
  'common.transfers': 'Transfers',
  'common.type': 'Type',
  'common.undoChanges': 'Undo Changes',
  'common.unlocked': 'Unlocked',
  'common.unsaved': 'Unsaved',
  'common.unsavedChanges': 'Unsaved Changes',

  'common.unselectAll': 'Unselect All',
  'common.update': 'Update',
  'common.updateFailed': 'Update Failed',
  'common.updatePayment': 'Update Payment',
  'common.updateTemplate': 'Update Template',
  'common.updated': 'Updated',
  'common.updating': 'Updating',
  'common.uploadDate': 'Upload Date',
  'common.uploadFile': 'Upload File',
  'common.uploadInformation': 'Upload Information',

  'common.uploadMessages': 'Upload Messages',
  'common.uploadMode': 'Upload Mode',
  'common.uploadTransactions': 'Upload Transactions',
  'common.uploadType': 'Upload Type',
  'common.uploadedBy': 'Uploaded By',
  'common.uploadedDateTime': 'Uploaded Date/Time',
  'common.uploadedRecords': 'Uploaded Records',
  'common.usd': 'USD',
  'common.usdAvailable': '<%= amount %> USD Available',
  'common.used': 'Used',
  'common.userCode': 'User ID',
  'common.userCompanyLimit': 'User Company Limit',
  'common.userId': 'User ID',

  'common.userName': 'User Name',
  'common.userOverallLimit': 'User Overall Limit',
  'common.userType': 'User Type',
  'common.usergroup': 'Customer ID',

  'common.value': 'Value',
  'common.verify': 'Verify',
  'common.verifyDeliveryPoints': 'Verify Delivery Points',
  'common.view': 'View',
  'common.viewChanges': 'View Changes',
  'common.viewCollection': 'View Collection',
  'common.viewDetails': 'View Details',
  'common.viewFileWarnings': 'View File Warnings',
  'common.viewMapDetails': 'View Map Details',
  'common.viewPayment': 'View Payment',
  'common.viewRecurringInstruction': 'View Recurring Instruction',
  'common.viewTransaction': 'View Transaction',
  'common.voiceNumber': 'Voice Number',
  'common.void': 'Void',
  'common.warning': 'Warning',
  'common.whenToDraw': 'When to Draw',
  'common.whenToSend': 'When to Send',
  'common.widget': 'Widget',
  'common.widget.crash':
    'Widget currently unavailable. Please contact your administrator if the problem persists.',
  'common.widget.notBuilt': `Widget "<%= widgetCode %>" Not Yet Built`,
  'common.wire': 'Wire',
  'common.wireApprovals': 'Wire Approvals',
  'common.wireDateTime': 'Wire Entry Date/Time',
  'common.wireDetails': 'Wire Details',
  'common.wireDomestic': 'Wire - Domestic',
  'common.wireFileImportMessages': 'Wire File Import Messages',
  'common.wireImports': 'Wire Imports',
  'common.wireInternational': 'Wire - International',

  'common.wireTransfer': 'Wire Transfer',
  'common.wireType': 'Wire Type',
  'common.wiresSent': 'Wire Sent',
  'common.workflow': 'Workflow',
  'common.workspace': 'Workspace',
  'common.yes': 'Yes',
  'common.yesContinue': 'Yes, Continue',
  'common.youAreAboutToModifyTransfer': 'You are about to modify a <%=type%> transfer.',
  'common.zero': 'Zero',
  'common.zeroAllAmounts': 'Zero All Amounts',
  'common.zeroAmount': 'Zero Amount',
  'common.zip': 'Zip',
  'common.zipCode': 'Zip Code',
  'common.empty': '-',
  'common.routingDetails': 'Routing Details',
  'common.pleaseSelect': '---Please Select---',
  'common.checking': 'Checking',
  'common.savings': 'Savings',
  'common.expeditedWireDomestic': 'Expedited (Wire - Domestic)',
  'common.internationalWireInternational': 'International (Wire - International)',
  'common.time.template.seconds': '<%= seconds %> seconds'
};
